//dependencies
import React, { useState } from "react";

import { faEyeSlash } from "@fortawesome/pro-solid-svg-icons";

// components
import Button from "../Button";
import css from "./RevealContent.module.scss";

interface IRevealContentProps {
	/**
	 * Label for the reveal button
	 * @default Reveal Content
	 */
	label: string;
	/**
	 * Override the default style for the reveal button positioning
	 * @default inputRevealButton
	 */
	className?: string;
	/**
	 * The content to be revealed
	 */
	children: React.ReactNode;
}

const RevealContent = (props: IRevealContentProps) => {
	const { label, children, className = "" } = props;

	const [isFocused, setIsFocused] = useState(false);

	const handleReveal = () => {
		setIsFocused(true);
	};

	return (
		<div className={`${css.componentWithBlur} ${isFocused ? css.focused : ""}`}>
			{children}
			<div className={css.positionContainer}>
				<Button
					onClick={handleReveal}
					className={`${css.inputRevealButton} ${className}`}
					isHollow={true}
					size="micro"
					icon={faEyeSlash}
					iconPosition="left"
				>
					{label}
				</Button>
			</div>
		</div>
	);
};

export default RevealContent;
